'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/render-if-broker.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _checkboxStacked = require('@marmalade/form/lib/components/checkbox/checkbox-stacked');
var _checkboxStacked2 = _interopRequireDefault(_checkboxStacked);
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var CheckboxWrapper = _glamorous2.default.div(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: theme.space_sm,
    paddingBottom: 0,
    marginBottom: theme.space_sm
  };
});
var RenderIfBroker = function (_Component) {
  _inherits(RenderIfBroker, _Component);
  function RenderIfBroker() {
    _classCallCheck(this, RenderIfBroker);
    return _possibleConstructorReturn(this, (RenderIfBroker.__proto__ || Object.getPrototypeOf(RenderIfBroker)).apply(this, arguments));
  }
  _createClass(RenderIfBroker, [{
    key: 'render',
    value: function render() {
      var checkbox = _react2.default.createElement(_checkboxStacked2.default, {
        name: this.props.checkboxName,
        fieldCss: {
          paddingBottom: 0
        },
        options: this.props.options,
        singleColumn: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        },
        __self: this
      });
      return this.props.broker ? _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 38
        },
        __self: this
      }, _react2.default.createElement(_message2.default, {
        type: 'warning',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        },
        __self: this
      }, this.props.children, _react2.default.createElement(CheckboxWrapper, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        },
        __self: this
      }, checkbox))) : null;
    }
  }]);
  return RenderIfBroker;
}(_react.Component);
RenderIfBroker.propTypes = {
  broker: _propTypes.bool.isRequired,
  children: _propTypes.node.isRequired,
  checkboxName: _propTypes.string.isRequired,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    text: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired
  }).isRequired).isRequired
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    broker: !!state.broker
  };
})(RenderIfBroker);